<template>
  <div>
    <div class="row" v-if="signedSession">
      <div
        class="col s12 animated zoomInLeft"
        id="leftContainment"
        :class="[
          windows.width >= 1200 ? 'l6' : 'l6',
          windows.width >= 600 && windows.width <= 900 ? 'm12' : 'm6'
        ]"
        :style="[
          windows.width >= 1200 ? 'display: block' : 'display: block',
          windows.width >= 600 && windows.width <= 910
            ? 'display: none'
            : 'display: block'
        ]"
      >
        <div class="card-panel hoverable" :class="{ blur: proccedBtn }">
          <h5>Airtime</h5>
          <form @submit.prevent="verifyDetails" id="form">
            <div class="row">
              <div class="input-field col s12 m12">
                <select
                  id="network"
                  class="icons"
                  v-model="fields.networks"
                  @change="getNetworkProvider(fields.networks)"
                >
                  <option value="" disabled selected
                    >Select a Network provider</option
                  >
                  <option
                    v-for="(network, index) in providers"
                    :key="index"
                    :value="index + 1"
                    :data-icon="getImage(network)"
                    class="left"
                  >
                    {{ network }}
                  </option>
                </select>
                <label>Network provider</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <input id="phone" type="text" v-model="fields.receiver" />
                <label for="phone">Phone Number</label>
              </div>
              <div class="input-field col s12 m6">
                <input
                  id="amount"
                  type="text"
                  v-model="fields.amount"
                  @change="formatNumber(fields.amount)"
                />
                <label for="amount">Amount</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input id="email" type="email" v-model="fields.email" />
                <label for="email">Email Address</label>
              </div>
            </div>
            <div class="row">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div class="col s12 m12" v-else>
                <button
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  :disabled="proccedBtn"
                >
                  <i class="material-icons right">send</i> Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        class="col s12"
        id="rightContainment"
        :class="[
          windows.width >= 1200 ? 'l6' : 'l6',
          windows.width >= 600 && windows.width <= 900 ? 'm12' : 'm6'
        ]"
      >
        <transition name="slide-fade">
          <div v-if="showSummary" class="card-panel z-depth-3">
            <h5>Transaction Summary</h5>
            <table class="highlight">
              <tbody>
                <tr>
                  <th>Network</th>
                  <td>
                    {{ selectedNetwork }}
                    <img
                      :src="getImage(selectedNetwork)"
                      class="responsive-img"
                      width="30px"
                      style="vertical-align: middle; float: right"
                    />
                  </td>
                </tr>
                <tr>
                  <th>Transaction ID</th>
                  <td>{{ transactionID }}</td>
                </tr>
                <tr>
                  <th>Phone Number</th>
                  <td>{{ fields.receiver }}</td>
                </tr>
                <tr>
                  <th>Amount</th>
                  <td>&#8358; {{ fields.amount }}</td>
                </tr>
                <tr>
                  <th>Email Address</th>
                  <td>{{ fields.email }}</td>
                </tr>
                <tr>
                  <th>Payment method</th>
                  <td>
                    <select
                      class="browser-default"
                      id="payoption"
                      v-model="payment_option"
                    >
                      <option value="" disabled selected
                        >Choose your option</option
                      >
                      <option value="1">Pay with Card</option>
                      <option value="2">Pay with Voucher</option>
                      <option value="3">Pay with USSD</option>
                      <!-- <option value="4">Pay with Bank Transfer</option> -->
                      <option value="4">Pay with Wallet</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row" v-show="proccedBtn">
              <div class="col s12 m12" style="margin-top: 15px">
                <div v-if="vending">
                  <img src="ui/img/loading.svg" alt="Time Loader" />
                  <p><i>Loading...</i></p>
                </div>
                <div v-else>
                  <div class="right">
                    <a
                      class="waves-effect waves-light btn-small"
                      @click="payOption(payment_option)"
                      >Pay</a
                    >
                  </div>
                  <a
                    class="waves-effect waves-light btn-small left"
                    @click="revert"
                    >Back</a
                  >
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Vending Status Modal Structure -->
      <div id="vendStatus" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
          <!-- <img src="ui/img/logo.png" width="18%" class="responsive-img"> -->
        </div>
        <div class="modal-content" style="margin-top: 30px">
          <div class="feedbackForm" v-if="!feedback">
            <div v-if="successModal">
              <img
                src="ui/img/success.png"
                width="12%"
                class="responsive-img"
              />
              <h6>Your order has been completed sucessfully.</h6>
            </div>
            <div v-if="!successModal">
              <img src="ui/img/failed.png" width="12%" class="responsive-img" />
              <h6>Order was not sucessful.</h6>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <h6><strong>Transaction Details</strong></h6>
                <p><strong>Transaction Ref:</strong> {{ transactionID }}</p>
                <p><strong>Payment Ref:</strong> {{ payment_ref }}</p>
              </div>
              <div class="col s12 m6">
                <h6><strong>Customer Details</strong></h6>
                <p>
                  {{ selectedNetwork }} &#8358; {{ fields.amount }} to
                  {{ fields.receiver }}
                </p>
                <p>
                  <strong>Email:</strong>
                  {{ fields.email == '' ? 'Not provided' : fields.email }}
                </p>
                <!-- <p><strong>Phone</strong> {{ fields.receiver }}</p> -->
              </div>
            </div>
            <hr style="width: 65%" />
            <div v-show="!feedbackSuccess && successModal">
              <div class="col s12 m6 l6">
                <h6><strong>How was your experience?</strong></h6>
                <a
                  href="#"
                  @click.prevent="
                    feedback = true
                    feedbackfield.satisfaction = true
                    feedbackfield.recommend = true
                  "
                >
                  <img
                    class="feedbackEmoji"
                    src="ui/img/happyface.png"
                    style="margin-right: 10px"
                  />
                </a>
                <a
                  href="#"
                  @click.prevent="
                    feedback = true
                    feedbackfield.satisfaction = false
                    feedbackfield.recommend = false
                  "
                >
                  <img class="feedbackEmoji" src="ui/img/sadface.png" />
                </a>
              </div>
              <div class="col s12 m6 l6">
                <h6><strong>Share with a friend</strong></h6>
                <i
                  @click="whatsApp"
                  class="fa fa-whatsapp feedbackEmoji"
                  style="font-size: 37px; cursor: pointer; color: #008000; margin-right: 15px"
                ></i>
                <!-- <i @click="whatsApp" class="fa fa-facebook feedbackEmoji" style="font-size: 37px; cursor: pointer;"></i> -->
              </div>
            </div>
          </div>
          <!-- <div class="row" style="clear: both; padding: 15px 0px 10px">
            <button class="btn-small" @click="createAccount('signup')">Create Account</button>
          </div> -->
          <div class="feedbackForm" v-if="feedback">
            <h5 style="margin-bottom: 40px">Customer feedback form</h5>
            <form @submit.prevent="sendFeedback">
              <div class="row">
                <div class="col s6 m6">
                  <div class="switch">
                    <strong>Are you satisfied with the service:</strong> <br />
                    <label>
                      No
                      <input
                        type="checkbox"
                        v-model="feedbackfield.satisfaction"
                      />
                      <span class="lever"></span>
                      Yes
                    </label>
                  </div>
                </div>
                <div class="col s6 m6">
                  <div class="switch">
                    <strong>Would you recommend irecharge to a friend: </strong
                    ><br />
                    <label>
                      No
                      <input
                        type="checkbox"
                        v-model="feedbackfield.recommend"
                      />
                      <span class="lever"></span>
                      Yes
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m10 offset-m1">
                  <textarea
                    class="materialize-textarea comment"
                    data-length="120"
                    maxlength="120"
                    v-model="feedbackfield.comment"
                  ></textarea>
                  <label for="textarea2">Comment</label>
                </div>
              </div>
              <div class="row" v-if="feedbackloading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div class="row" style="margin-bottom: 50px" v-else>
                <a
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  @click="feedback = false"
                  style="margin-right: 10px"
                  >No Thanks</a
                >
                <a
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  @click="sendFeedback"
                  >Send Feedback</a
                >
              </div>
            </form>
          </div>
          <p style="clear:both">
            <img src="ui/img/thanks.png" width="21%" class="responsive-img" />
          </p>
        </div>
      </div>
      <!-- Vending Status Modal Structure -->
      <!-- Voucher Modal Structure -->
      <div id="voucher" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
          <img src="ui/img/logo.png" width="18%" class="responsive-img" />
        </div>
        <div class="modal-content">
          <form>
            <h5>Enter Voucher Code</h5>
            <div class="row">
              <div class="input-field col s12 m8 offset-m2">
                <input
                  placeholder="Voucher Code"
                  id="voucher_code"
                  type="text"
                  v-model="voucher_code"
                />
              </div>
            </div>
            <div class="row" v-if="vouching">
              <div class="col s4 offset-s4 m4 offset-m4">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
            </div>
            <div class="row" v-else>
              <a
                class="waves-effect waves-light btn-small"
                type="submit"
                @click="verifyVoucher"
                >Redeem Voucher</a
              >
            </div>
          </form>
        </div>
      </div>
      <!-- Voucher Modal Structure -->
      <ussd-code
        :transactionID="transactionID"
        :coralCode="coralpayCode"
        :service="service"
        @ussd-complete="ussdComplete"
      />
      <!-- Wallet Modal Structure -->
      <div id="wallet" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
        </div>
        <div class="modal-content">
          <form>
            <h5 style="margin: 30px">Verify Wallet Debit</h5>
            <div class="row">
              <div class="input-field col s12 m8 offset-s2 offset-m2">
                <input
                  id="wallet_username"
                  type="text"
                  v-model="wallet_username"
                />
                <label for="email_phone" class="active"
                  >Email/Phone number</label
                >
              </div>
              <div
                class="input-field col s12 m8 offset-s2 offset-m2"
                v-if="reveal == true"
              >
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility_off</i
                >
                <input id="pass" type="text" v-model="wallet_password" />
                <label for="pass" class="active">Password</label>
              </div>
              <div
                class="input-field col s12 m8 offset-s2 offset-m2"
                v-if="reveal == false"
              >
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility</i
                >
                <input
                  id="password"
                  type="password"
                  v-model="wallet_password"
                />
                <label for="password" class="active">Password</label>
              </div>
            </div>
            <div class="row" v-if="walletProcess">
              <div class="col s4 offset-s4 m4 offset-m4">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
            </div>
            <div class="row" v-else>
              <a
                class="waves-effect waves-light btn-small"
                type="submit"
                @click="verifyWallet"
                >Validate</a
              >
            </div>
          </form>
        </div>
      </div>
      <!-- Wallet Modal Structure -->
      <create-account :attempt="updateAttempt" />
    </div>
    <div v-else>
      <welcome @modal-option="selectedView" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import BankTransfer from '@/components/modals/BankTransfer.vue'
import UssdCode from '@/components/modals/UssdCode.vue'
import Welcome from "@/components/partials/Welcome.vue"
import CreateAccount from "@/components/modals/CreateAccount.vue"
export default {
  name: 'airtime',
  metaInfo: {
    // all titles will be injected into this template
    titleTemplate: '%s | Airtime',
    meta: [
      { name: 'description', content: 'iRecharge.com.ng Purchase GLO, MTN, AIRTEL,ETISALAT Airtime Online Easily with iRecharge' },
      { name: 'keywords', content: 'Buy airtime online, buy MTN airtime, buy internet data subscription, Etisalat Glo Airtel Airtime, DSTV payment, DSTV subscription, GOTV payment, PHCN payment, Login to iRecharge, Buy MTN Airtime, Glo Etisalat Airtel Airtime, Internet Data subscription, GOTV DSTV startimes payment, buy airtime online, online data, smile subscription, online data recharge, buy data online, airtel data, glo data,  Airtel VTU,  Smile Data Purchase, Spectranet Data Subscription, Smile Data Subscription' },
    ]
  },
  components: {
    BankTransfer,
    UssdCode,
    Welcome,
    CreateAccount
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if(localStorage.getItem('phone') !== null) {
      if(sessionStorage.getItem('status') === null) {
        // localStorage.setItem('userType', 2)
        if(localStorage.getItem('userType') != "2" || localStorage.getItem('userType') != "1") {
          this.signedSession = true
        } else {
          this.signedSession = false
        }
      } else {
        this.signedSession = true
      }
    } else {
      this.signedSession = false
    }
  },
  mounted() {
    $('.bills__side__wrapper').removeClass('left_out')
    if(localStorage.getItem('airtime') !== null) {
      var airtime = JSON.parse(localStorage.getItem('airtime'));
      this.fields.receiver = localStorage.getItem('phone')
      $('#phone').val(this.fields.receiver)
      if(airtime.message === "Successful") { // if the transaction isn't empty for the user
        this.fields.amount = airtime.amount
        $('#amount').val(this.fields.amount)
        this.fields.receiver = airtime.receiver
        $('#phone').val(this.fields.receiver)
        this.fields.email = airtime.email
        $('#email').val(this.fields.email)
        this.fields.networks = this.getNetworkProvider(airtime.network)
        if(airtime.network == 'Etisalat') {
          airtime.network = '9mobile'
        }
        var sol = $.inArray(airtime.network, this.providers)
        $('#network').val(sol + 1)
      }
    } else {
      this.fields.receiver = localStorage.getItem('phone')
      $('#phone').val(this.fields.receiver)
    }
    $('select').formSelect()
    this.initModal()
    this.wallet_username = this.fields.receiver
    M.updateTextFields()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  data() {
    return {
      reveal: false,
      signedSession: false,
      mode: 2,
      appkey_test: 'FLWPUBK-1ee29936e2002a3413171760bc1c4d6c-X',
      appkey_live: 'FLWPUBK-80b1575515b0e047f99d8a929de856c7-X',
      windows: {
        width: 0,
        height: 0
      },
      providers: ['MTN', 'GLO', 'Airtel', '9mobile'],
      fields: {
        "source":"iRecharge",
        "category":"iRecharge",
        "username":"",
        "platform":"Website",
        "d_uuid":"12345",
        "d_platform":"Website",
      },
      feedback: false,
      feedbackSuccess: false,
      feedbackloading: false,
      feedbackfield: {
        "service":"airtime"
      },
      loading: false,
      vending: false,
      proccedBtn: false,
      selectedNetwork: '',
      showSummary: false,
      mobileView: false,
      transactionID: '',
      payment_ref: '',
      payment_option: '',
      voucher_code: '',
      payment_method: '',
      ussdoption: '',
      modalInstance: {},
      vouching: false,
      successModal: false,
      service: '',
      wallet_password: '',
      wallet_username: '',
      walletProcess: false,
      updateAttempt: '',
      coralpayCode: ''
    }
  },
  methods: {
    selectedView(option) {
      this.$emit('modal-option', option)
    },
    visibility() {
      this.reveal = !this.reveal
    },
    verifyWallet() {
      if(this.ValidateWalletData()) {
        this.reveal = false
        this.walletProcess = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', 'login')
        bodyFormData.set('action', 'login')
        bodyFormData.set('inputEmail', this.wallet_username)
        bodyFormData.set('inputPassword', this.wallet_password)
        this.axios.post('control1.php', bodyFormData)
        .then(response => {
          if(response.data.status == 1) {
            $('.toast').hide()
            M.toast({ html: 'Verification Successful, Please wait while we vend...', classes: 'success' })
            let obj = {
              "transaction_id": this.transactionID,
              "payment_ref": this.transactionID,
              "payment_method": this.payment_method,
              "voucher_code": this.voucher_code,
              "user_numid": response.data.userid
            }
            obj.passcode = this.hash(this.transactionID)
            this.axios.post('https://irecharge.com.ng/api/airtime/vend.php', obj)
            .then(response => {
              if(response.data.status == "0") {
                this.successModal = true
                this.revert()
                // this.emptyFormInputs()
                this.payment_ref = response.data.payment_ref
                this.modalInstance[0].open()
                this.modalInstance[4].close()
                this.disableFormInputs(false)
                this.updateStorage(
                  this.fields.amount, 
                  this.fields.email,
                  this.fields.networks, 
                  this.fields.receiver
                )
                this.walletProcess = false
                $('.toast').hide()
                M.toast({ html: response.data.message, classes: 'success' })
              } else {
                this.proccedBtn = true
                $('.toast').hide()
                M.toast({ html: response.data.message, classes: 'error' })
                this.walletProcess = false
              }
            })
            .catch(error => {
              $('.toast').hide()
              M.toast({ html: 'Could not send request, check network.', classes: 'error' })
              this.walletProcess = false
            })
          } else {
            this.walletProcess = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.walletProcess = false
        })
      }
    },
    ussdComplete() {
      this.disableFormInputs(false);
      this.revert();
      this.updateStorage(
        this.fields.phone, 
        this.fields.email,
        this.fields.receiver
      )
      this.vending = false,
      this.showSummary = false
      this.proccedBtn = false
      // this.emptyFormInputs()
    },
    ValidateWalletData() {
      if (this.wallet_username != '') {
        if (this.wallet_password != '') {
          return true
        } else {
          $('.toast').hide()
          M.toast({ html: 'Password is required', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Email/Phone number is required', classes: 'info' })
      }
    },
    formatNumber(num) {
      var result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      $('#amount').val(result)
    },
    createAccount(option) {
      this.$emit('modal-option', option)
      document.getElementById('myNav').style.width = '100%'
      this.modalInstance[0].close()
    },
    initModal() {
      // initialize modal for the document
      const option = { dismissible: false, endingTop: '6%', preventScrolling: true }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    payOption(option) {
      if(option == '') {
        $('.toast').hide()
        M.toast({ html: 'Kindly select payment option', classes: 'info' })
      } else {
        if(option == '1') { // Card payment option
          this.payment_method = 'Card'
          this.RavePay()
        }
        if(option == '2') { // Voucher payment option
          this.payment_method = 'Voucher'
          this.modalInstance[1].open()
        }
        if(option == '3') { // USSD code payment option
          this.service = 'airtime'
          this.generateUSSDCode()
        }
        // if(option == '4') { // Bank transfer payment option
        //   this.modalInstance[3].open()
        // }
        if(option == '4') { // Wallet payment option
          this.payment_method = 'Wallet'
          this.modalInstance[3].open()
        }

      try{ 
            __adroll.track("pageView", {"segment_name":"cbb9972f"}) 
        } catch(err) {}
        
      }


    },
    generateUSSDCode() {
      this.vending = true
      let obj = {}
      obj.transaction_id = this.transactionID
      obj.service = this.service
      obj.passcode = this.hash(obj.transaction_id)
      this.axios.post('https://irecharge.com.ng/api/coralpay/generate.php', obj)
        .then(response => {
          if(response.data.status == "0") {
            this.coralpayCode = response.data.code
            this.modalInstance[2].open()
          } else {
            $('.toast').hide()
            M.toast({ html: 'Error generating code, click "PAY" again', classes: 'error' })
          }
          if (response.data.message == "Unauthorized Access") {
            this.disableFormInputs(false)
            $('.toast').hide()
            M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.vending = false
        })
    },
    whatsApp() {
      window.open('https://api.whatsapp.com/send?phone=&text=Hello!%20I%27ve%20just%20made%20some%20transactions%20seamlessly%20right%20now.%20Try%20it%20out%20here,%20you%27ll%20enjoy%20their%20service%20https://irecharge.ng', '_blank');
    },
    sendFeedback() {
      this.feedbackloading = true
      let obj = {
        recommend: '',
        satisfaction: '',
        service: this.feedbackfield.service,
        transaction_id: this.transactionID,
        comment: this.feedbackfield.comment
      }
      if(this.feedbackfield.recommend) {
        obj.recommend = "yes"
      } else {
        obj.recommend = "no"
      }
      if(this.feedbackfield.satisfaction) {
        obj.satisfaction = "yes"
      } else {
        obj.satisfaction = "no"
      }
      obj.passcode = this.hash(this.transactionID)
      this.axios.post('https://irecharge.com.ng/api/feedback/submit.php', obj)
      .then(response => {
        if(response.data.status == "0") {
          this.feedbackloading = false
          this.feedback = false
          this.feedbackSuccess = true
          $('.toast').hide()
          M.toast({ html: 'Feedback received', classes: 'success' })
        } else {
          this.feedbackloading = false
          $('.toast').hide()
          M.toast({ html: response.data.message, classes: 'info' })
        }
      })
      .catch(error => {
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.vouching = false
      })
    },
    verifyVoucher() {
      if(this.payment_method == 'Voucher') {
        if(this.voucher_code == '') {
          $('.toast').hide()
          M.toast({ html: 'Kindly enter your voucher code', classes: 'info' })
        } else {
          this.vouching = true
          let obj = {
            "transaction_id": this.transactionID,
            "payment_ref": this.transactionID,
            "payment_method": this.payment_method,
            "voucher_code": this.voucher_code,
          }
          obj.passcode = this.hash(this.transactionID)
          this.axios.post('https://irecharge.com.ng/api/airtime/vend.php', obj)
          .then(response => {
            if(response.data.status == "0") {
              this.successModal = true
              this.revert()
              // this.emptyFormInputs()
              this.payment_ref = response.data.payment_ref
              this.modalInstance[0].open()
              this.modalInstance[1].close()
              this.disableFormInputs(false)
              this.updateStorage(
                this.fields.amount, 
                this.fields.email,
                this.fields.networks, 
                this.fields.receiver
              )
              this.vouching = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'success' })
            } else {
              this.proccedBtn = true
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'error' })
              this.vouching = false
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({ html: 'Could not send request, check network.', classes: 'error' })
            this.vouching = false
          })
        }
      }
    },
    vendAirtime() {
      let obj = {
        "transaction_id": this.transactionID,
        "payment_ref": this.payment_ref,
        "payment_method": this.payment_method,
        "voucher_code": "",
      }
      obj.passcode = this.hash(this.transactionID)
      this.axios.post('https://irecharge.com.ng/api/airtime/vend.php', obj)
      .then(response => {
        if(response.data.message == "Successful") {
          this.successModal = true
          this.showSummary = false
          this.proccedBtn = false
          // this.emptyFormInputs()
          this.payment_ref = response.data.payment_ref
          this.modalInstance[0].open()
          this.disableFormInputs(false)
          this.vending = false
          this.updateStorage(
            this.fields.amount, 
            this.fields.email,
            this.fields.networks, 
            this.fields.receiver
          )
          $('.toast').hide()
          M.toast({ html: 'Payment was sucessful.', classes: 'success' })
          this.revert()
        } else {
          this.successModal = false
          this.showSummary = false
          this.proccedBtn = false
          this.disableFormInputs(true)
          this.modalInstance[0].open()
          this.vending = true
          $('.toast').hide()
          M.toast({ html: response.data.message, classes: 'error' })
        }
      })
      .catch(error => {
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.loading = false
      })
    },
    updateStorage(amount, email, network, receiver) {
      var obj = {
        amount: amount,
        email: email,
        message: "Successful",
        network: network,
        phone: receiver,
        receiver: receiver,
        service: "airtime",
      }
      localStorage.setItem('airtime', JSON.stringify(obj))
    },
    RavePay() {
      const that = this
      this.vending = true
      let appkey = this.appkey_test
      if(this.mode == 2) {
        appkey = this.appkey_live
      }
      var x = getpaidSetup(
        {
          PBFPubKey: appkey,
          customer_email: this.fields.email == undefined || this.fields.email == '' ? 'website@istrategytech.com' : this.fields.email,
          amount: this.fields.amount,
          customer_phone: this.fields.receiver,
          currency: "NGN",
          payment_method: "both",
          txref: this.transactionID,
          onclose:function(response) {
            that.emptyFormInputs()
            that.disableFormInputs(false)
            that.vending = false
          },
          callback:function(response) {
            // let txref = response.tx.txRef
            let chargeResponse = response.tx.chargeResponseCode
            if (chargeResponse == "00" || chargeResponse == "0") {
              // redirect to a success page
              that.fields.d_uuid = response.tx.IP
              that.payment_ref = response.tx.txRef
              // vend airtime now
              that.vendAirtime()
              setTimeout(() => {
                x.close()
              }, 3000);
            } else {
              // payment could not be completed
              setTimeout(() => {
                x.close()
              }, 3000);
              that.successModal = false
              that.showSummary = false
              that.proccedBtn = false
              that.disableFormInputs(true)
              that.modalInstance[0].open()
              that.vending = false
            }
          }
        }
      );
    },
    verifyDetails() {
      if (this.ValidateData()) {
        this.loading = true
        this.setParameters() // set the device name and model
        this.fields.passcode = this.hash(this.fields.receiver)
        this.axios.post('https://irecharge.com.ng/api/airtime/verify.php', this.fields)
          .then(response => {
            if(response.data.status == "0") {
              this.transactionID = response.data.transaction_id
              this.proccedBtn = true
              this.showSummary = true
              this.loading = false
              $('.toast').hide()
              // M.toast({ html: 'Kindly verify transaction', classes: 'success' })
              // display the create account modal
              if(localStorage.getItem('user') == "false") {
                if(localStorage.getItem('attempts') <= "1") {
                  this.modalInstance[5].open()
                  this.updateAttempt = localStorage.getItem('attempts')
                  localStorage.setItem('attempts', 0)
                }
              }
              if (this.windows.width <= 900) {
                const formInput = document.querySelector('#leftContainment')
                formInput.style.display = 'none'
              }
              if (this.windows.width >= 1200) {
                this.mobileView = true
              }
            } else {
              this.loading = false
              disableFormInputs(false)
              $('.toast').hide()
              M.toast({ html: 'Poor network, Please try again', classes: 'error' })
            }
            if(response.data.message == "Unauthorized Access") {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({ html: 'Could not send request, check network.', classes: 'error' })
            this.loading = false
            this.disableFormInputs(false)
          })
      }
    },
    setParameters() {
      this.fields.d_model = window.navigator.vendor
      this.fields.d_name = window.navigator.vendor
    },
    ValidateData() {
      if (this.fields.networks) {
        if (this.fields.receiver) {
          if (this.fields.receiver.toString().length === 11) {
            if (this.fields.amount) {
              if (this.fields.amount >= 50) {
                this.disableFormInputs(true)
                return true
              } else {
                $('.toast').hide()
                M.toast({ html: 'You cannot purchase lesser than NGN50 Airtime', classes: 'info'})
              }
            } else {
              $('.toast').hide()
              M.toast({ html: 'Amount field is required!', classes: 'info' })
            }
            } else {
              $('.toast').hide()
              M.toast({ html: 'Phone number must be 11 characters', classes: 'info' })
            }
          } else {
            $('.toast').hide()
            M.toast({ html: 'Phone number is required!', classes: 'info' })
          }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Please select a network!', classes: 'info' })
      }
    },
    getNetworkProvider(id) {
      // resolve network names
      if (id === 1 || id === 'MTN') {
        this.selectedNetwork = 'MTN'
        this.fields.network = 'MTN'
      } else if (id === 2 || id === 'Glo') {
        this.selectedNetwork = 'GLO'
        this.fields.network = 'Glo'
      } else if (id === 3 || id === 'Airtel') {
        this.selectedNetwork = 'Airtel'
        this.fields.network = 'Airtel'
      } else {
        this.selectedNetwork = '9mobile'
        this.fields.network = 'Etisalat'
      }
    },
    handleResize() {
      this.windows.width = window.innerWidth
      this.windows.height = window.innerHeight
    },
    getImage(name) {
      return `ui/img/airtime/${name}.jpg`
    },
    disableFormInputs(option) {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.disabled = option
      })
      formSelect.forEach(function(item) {
        item.disabled = option
      })
    },
    revert() {
      const formInput = document.querySelector('#leftContainment')
      formInput.style.display = 'block'
      this.proccedBtn = false
      this.showSummary = false
      this.disableFormInputs(false)
    },
    emptyFormInputs() {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.value = ''
      })
      formSelect.forEach(function(item) {
        item.value = 'Select option'
      })
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>

<style scoped>
.select-wrapper input.select-dropdown {
  text-align: center;
}
#voucher p {
  margin-top: 30px;
}
.modal .modal-content {
  padding: 0px 24px 24px;
}
</style>
